import angular from 'angular'

const listPage = require('./view/list.html')
const infoPage = require('./view/info.html')
const detailPage = require('./view/detail.html')
const listCtrl = require('./list')
const infoCtrl = require('./info')
const detailCtrl = require('./detail')

function configRouter($stateProvider) {
    $stateProvider.state('outputManage.fullElectricInvoice.drawer', {
        url: '/drawer',
        abstract: true,
        template: '<div ui-view></div>',
        default: 'outputManage.fullElectricInvoice.drawer.list',
        title: '开票员管理',
    })
    $stateProvider.state('outputManage.fullElectricInvoice.drawer.list', {
        url: '/list',
        template: listPage,
        controller: 'drawerListCtrl',
    })
    $stateProvider.state('outputManage.fullElectricInvoice.drawer.add', {
        url: '/add',
        template: infoPage,
        controller: 'drawerInfoCtrl',
        title: '新增',
    })
    $stateProvider.state('outputManage.fullElectricInvoice.drawer.edit', {
        url: '/edit/:drawerId/:isOriginalDrawer',
        template: infoPage,
        controller: 'drawerInfoCtrl',
        title: '编辑',
    })
    $stateProvider.state('outputManage.fullElectricInvoice.drawer.detail', {
        url: '/detail/:drawerId',
        template: detailPage,
        controller: 'drawerDetailCtrl',
        title: '详情',
    })
}

export default angular
    .module('outputManage.fullElectricInvoice.drawer', [])
    .config(['$stateProvider', configRouter])
    .controller('drawerListCtrl', listCtrl.default)
    .controller('drawerDetailCtrl', detailCtrl.default)
    .controller('drawerInfoCtrl', infoCtrl.default)
    .name



// WEBPACK FOOTER //
// ./src/app/outputManage/fullElectricInvoice/drawer/index.js